import React, { useState, useEffect } from "react";
import { emptyListing } from "../models/listingModel";
import { useAuth } from "../auth/AuthContext";
import { useTranslation } from "react-i18next";
import StepType from "../components/addListing/StepType";
import StepPurpose from "../components/addListing/StepPurpose";
import StepBuilding from "../components/addListing/StepBuilding";
import StepCondition from "../components/addListing/StepCondition";
import StepRooms from "../components/addListing/StepRooms";
import StepLocation from "../components/addListing/StepLocation";
import StepPriceAreaProject from "../components/addListing/StepPriceAreaProject";
import StepAmenities from "../components/addListing/StepAmenities";
import StepPhotosDescription from "../components/addListing/StepPhotosDescription";
import { useLocation, useNavigate } from "react-router-dom";
import { publishListing } from "../services/publishListing";

  export default function AddListing() {

 const { t } = useTranslation();

  const { user } = useAuth();

const location = useLocation();
const navigate = useNavigate();

const editingListing = location.state?.listing || null;
const isEditMode = !!editingListing;
useEffect(() => {
  if (isEditMode && !editingListing?.id) {
    navigate("/");
  }
}, [isEditMode, editingListing, navigate]);


  const [step, setStep] = useState(1);
  const [listing, setListing] = useState(() => {
  if (editingListing) {
    return {
      ...emptyListing,
      ...editingListing,
    
      // 🔥 ADD THIS LINE
      bathrooms:
        editingListing.bathrooms != null
          ? String(editingListing.bathrooms)
          : "",


    subType: Array.isArray(editingListing.subType)
        ? editingListing.subType
        : editingListing.subType
          ? [editingListing.subType]
          : [],
    };
  }
  return { ...emptyListing };
});

  const [submitting, setSubmitting] = useState(false);

  // ✅ Clear building if type becomes land
  useEffect(() => {
  if (listing.type === "land" && listing.building !== "") {
    setListing((prev) => ({
      ...prev,
      building: "",
      condition: "",
      renovation: "",
      rooms: "",
      bathrooms: "",
      bedrooms: "",
      floor: "",
      floors: "",
    }));
  }
}, [listing.type, listing.building, listing.condition]);

const handleSubmit = async () => {
  if (submitting) return;

  await publishListing({
    listing,
    user,
    isEditMode,
    editingListing,
    submitting,
    setSubmitting,
    navigate,
    t,
  });
};

  const goNextFromPurpose = () => {
    if (listing.type === "land") {
      setStep(6);
    } else {
      setStep(3);
    }
  };

  return (
    <div className="add-listing">


      {step === 1 && (
        <StepType
          listing={listing}
          setListing={setListing}
          onNext={() => setStep(2)}
        />
      )}

      {step === 2 && (
        <StepPurpose
          listing={listing}
          setListing={setListing}
          onBack={() => setStep(1)}
          onNext={goNextFromPurpose}
        />
      )}

      {step === 3 && listing.type !== "land" && (
        <StepBuilding
          listing={listing}
          setListing={setListing}
          onBack={() => setStep(2)}
          onNext={() => setStep(4)}
        />
      )}

      {step === 4 && listing.type !== "land" && (
        <StepCondition
          listing={listing}
          setListing={setListing}
          onBack={() => setStep(3)}
          onNext={() => setStep(5)}
        />
      )}

      {step === 5 && listing.type !== "land" && (
        <StepRooms
          listing={listing}
          setListing={setListing}
          onBack={() => setStep(4)}
          onNext={() => setStep(6)}
        />
      )}

      {step === 6 && (
        <StepLocation
          listing={listing}
          setListing={setListing}
          onBack={() =>
            listing.type === "land"
              ? setStep(2)
              : setStep(5)
          }
          onNext={() => setStep(7)}
        />
      )}

      {step === 7 && (
        <StepPriceAreaProject
          listing={listing}
          setListing={setListing}
          onBack={() => setStep(6)}
          onNext={() => setStep(8)}
        />
      )}

      {step === 8 && (
        <StepAmenities
          listing={listing}
          setListing={setListing}
          onBack={() => setStep(7)}
          onNext={() => setStep(9)}
        />
      )}

      {step === 9 && (
        <StepPhotosDescription
          listing={listing}
          setListing={setListing}
          onBack={() => setStep(8)}
          onSubmit={handleSubmit}
          submitting={submitting}
        />
      )}

    </div>
  );
}
